var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-heading',{staticClass:"step-one",attrs:{"level":"h5"}},[_vm._v(_vm._s(_vm.$t('sendhub.emailSmsHub.step_one')))]),_c('emailHub'),_c('app-heading',{staticClass:"step-two",attrs:{"level":"h5"}},[_vm._v(_vm._s(_vm.$t('sendhub.emailSmsHub.step_two')))]),_c('smsHub')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }